const normalizeNumber = (value: number, min: number, max: number): number => {
	if (min === max) {
		return 0.5
	}
	if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max)) {
		console.warn('Normalization warning: non-finite values detected, returning 0')
		return 0
	}
	return (value - min) / (max - min)
}

export default normalizeNumber
